import { Nav, Footer } from "../components/Nav";

import { useEffect } from "react";
import arrow from "../images/arrow.svg";
import HoneyBuddyThumbnail from "../images/HoneyBuddy/HoneyBuddy Thumbnail.jpg";

import SMTThumbnail from "../images/SMT/SMT Thumbnail.png";
import CDMThumbnail from "../images/CDM/CDM Thumbnail.png";
import TaskBuddyThumbnail from "../images/TaskBuddy/TaskBuddy Thumbnail.png";
import CakeryThumbnail from "../images/Cakery/Cakery Thumbnail.png";
import MemologThumbnail from "../images/Memolog/Memolog Thumbnail.png";
import WebcrackThumbnail from "../images/WebCrack/Webcrack Thumbnail.png";
import ACMWThumbnail from "../images/ACMW/ACM-W Thumbnail.png";
import { LargeCard, SmallCard } from "../components/Cards";
import { ConnectSection } from "../components/ProjectDetails";
export default function Portfolio() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <Nav />
      <main className="main-container">
        {/*Intro Section*/}
        <section id="intro-section">
          <div className="intro-container">
            <h1>Hi, I'm Mandy!</h1>
            <h1>I design & code.</h1>
            <p>
              <strong>💡 I'm currently: </strong> <br />
              Web and Graphic Design Intern @Leavey Executive Center
              <br />
              Research Assistant @EPIC Laboratory
            </p>
            <p>
              <strong>🎯 Aspiring UI/UX Designer</strong> <br />
              with Front-End Development Expertise
            </p>
            {/*<p>
              <strong>💖 Passionate about bringing ideas to life </strong>
              <br /> & designing intuitive experiences that shape how we
              interact with technology.
            </p>*/}
            <button
              className="primary-button"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("project-section")?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Check out my projects
            </button>
            <img src={arrow} id="arrow" alt="Arrow" />
          </div>
        </section>

        {/*Projects Section*/}
        <section id="project-section">
          <h1 id="projects">Featured Projects</h1>
          <div id="project-catalog">
            {/*HoneyBuddy*/}
            <LargeCard
              img={HoneyBuddyThumbnail}
              title="HoneyBuddy"
              subtitle="UI/UX Design, UX Research"
              description="Improve your quality-of-life with HoneyBuddy, the easy way to build good habits!"
              link="/honeybuddy"
            />
            {/*SMT*/}
            <LargeCard
              img={SMTThumbnail}
              title="Who's on First?"
              subtitle="Full-stack Development, UI Design"
              description="A baseball defense simulator tool for coaches and players!"
              link="/smt"
            />
            {/*Children's Discovery Museum*/}
            <LargeCard
              img={CDMThumbnail}
              title="Children’s Discovery Museum"
              subtitle="UI/UX Design, Redesign"
              description="Playful reimagination of my favorite childhood museum's website!"
              link="/cdm"
            />
            {/*TaskBuddy*/}
            {/*
            <LargeCard
              img={TaskBuddyThumbnail}
              title="TaskBuddy"
              subtitle="Full-stack Development, Database"
              description="Boost your productivity with our web-based task management app!"
              link="/honeybuddy"
            />
            */}
          </div>

          {/*small card project catalog*/}
          <h1 id="additional-project-title">Other Projects</h1>
          <div id="small-catalog">
            {/*cakery*/}
            <SmallCard
              img={CakeryThumbnail}
              title="Cakery"
              subtitle="Logo and Brand Design"
              link="/cakery"
            />

            {/*TaskBuddy*/}
            <SmallCard
              img={TaskBuddyThumbnail}
              title="Task Buddy"
              subtitle="Full-Stack, Database"
              link="/taskbuddy"
            />

            {/*Memolog*/}
            <SmallCard
              img={MemologThumbnail}
              title="MemoLog"
              subtitle="Mobile App Design"
              link="/memolog"
            />

            {/*WebCrack*/}
            <SmallCard
              img={WebcrackThumbnail}
              title="WebCrack"
              subtitle="Hackathon Finalist"
              link="/webcrack"
            />

            {/*ACM-W*/}
            <SmallCard
              img={ACMWThumbnail}
              title="ACM-W Flyers"
              subtitle="Graphic Design"
              link="/acmw"
            />
          </div>
        </section>
      </main>
      <ConnectSection />
      <Footer />
    </>
  );
}
